export const GET_VENDER_CONTACT_LIST_REQUEST = "GET_VENDER_CONTACT_LIST_REQUEST"
export const GET_VENDER_CONTACT_LIST_SUCCESS = "GET_VENDER_CONTACT_LIST_SUCCESS"
export const SYNC_VENDER_CONTACT_REQUEST = "SYNC_VENDER_CONTACT_REQUEST"
export const SYNC_VENDER_CONTACT_SUCCESS = "SYNC_VENDER_CONTACT_SUCCESS"
export const ADD_VENDER_CONTACT_REQUEST = "ADD_VENDER_CONTACT_REQUEST"
export const ADD_VENDER_CONTACT_SUCCESS = "ADD_VENDER_CONTACT_SUCCESS"
export const DELETE_VENDER_CONTACT_REQUEST = "DELETE_VENDER_CONTACT_REQUEST"
export const DELETE_VENDER_CONTACT_SUCCESS = "DELETE_VENDER_CONTACT_SUCCESS"